import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {RangeSizesType} from '../../../../../types/Sizes'

type PropsType = {
  /** The size of the bottom padding. Only spacing sizes from the theme are accepted */
  paddingBottomSize?: RangeSizesType

  /** The size of the left padding. Only spacing sizes from the theme are accepted */
  paddingLeftSize?: RangeSizesType

  /** The size of the right padding. Only spacing sizes from the theme are accepted */
  paddingRightSize?: RangeSizesType

  /** The size of the padding for all sides. Only spacing sizes from the theme are accepted. Each side will be overwritten if it is passed separately */
  paddingSize?: RangeSizesType

  /** The size of the top padding. Only spacing sizes from the theme are accepted */
  paddingTopSize?: RangeSizesType
}

export const ContentWrapper = styled('div')<PropsType>(
  ({
    paddingSize = 's500',
    paddingBottomSize,
    paddingLeftSize,
    paddingRightSize,
    paddingTopSize,
    theme
  }) => css`
    padding-bottom: ${theme.layout.spacing[paddingBottomSize || paddingSize]}px;
    padding-left: ${theme.layout.spacing[paddingLeftSize || paddingSize]}px;
    padding-right: ${theme.layout.spacing[paddingRightSize || paddingSize]}px;
    padding-top: ${theme.layout.spacing[paddingTopSize || paddingSize]}px;
  `
)

export default ContentWrapper
